export default __webpack_public_path__ + "static/media/topaz-logo.f7900910.svg";